import React, { Component } from 'react'
import { Spin, Table } from 'antd'
import moment from 'moment'
import { getSorterStringFn } from '../../../../util'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id_object',
        sorter: (a, b) => a.id - b.id,
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/stop-calls/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number',
        sorter: (a, b) => {
          if (a.number === null) {
            return -1
          } else if (b.number === null) {
            return 1
          }
          return a.number - b.number
        }
      },
      {
        title: 'Job ID',
        dataIndex: 'job_id',
        sorter: (a, b) => a.job_id - b.job_id
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        sorter: getSorterStringFn('job_name')
      },
      {
        title: 'Company',
        dataIndex: 'company_name',
        sorter: getSorterStringFn('company_name')
      },
      {
        title: 'Elevators',
        dataIndex: 'elevators',
        sorter: getSorterStringFn('elevators')
      },
      {
        title: 'Caller Name',
        dataIndex: 'caller_name',
        sorter: getSorterStringFn('caller_name')
      },
      {
        title: 'Complaint',
        dataIndex: 'complaint',
        sorter: getSorterStringFn('complaint')
      },
      {
        title: 'Mechanic',
        dataIndex: 'mechanic',
        sorter: getSorterStringFn('mechanic')
      },
      {
        title: 'Solution',
        dataIndex: 'solution',
        sorter: getSorterStringFn('solution')
      },
      {
        title: 'Billable',
        dataIndex: 'billable',
        sorter: (a, b) => a.billable - b.billable
      },
      {
        title: 'Status',
        dataIndex: 'status',
        sorter: getSorterStringFn('status')
      },
      {
        title: 'Stop Call Date',
        dataIndex: 'stop_call_date',
        sorter: (a, b, order) => {
          return new Date(a.stop_call_date).getTime() - new Date(b.stop_call_date).getTime()
        }
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    return fullReport.map((item, index) => {
      item.stop_call_date = moment(new Date(item.stop_call_date)).format('YYYY-MM-DD')
      item.key = item.id
      item.id_object = {
        job_id: item.job_id,
        job_type: item.job_type,
        id: item.id
      }
      return item
    })
  }

  iterateStopCalls = () => {
    const { fullReport } = this.props
    return fullReport.map((stopCall, index) => stopCall)
  }
  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <h4>Stop Calls</h4>
              <Table
                pagination={false}
                columns={this.getColumns()}
                size="small"
                dataSource={this.getData()}
                style={{ backgroundColor: 'white' }}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/stop-calls/ListItems.js